import { IconLock } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { Alert } from "@/components/ui";
import { useUserPermisos } from "@/lib/auth-store";

interface Props {
  /** Permisos permitidos · si el usuario tiene CUALQUIERA renderiza children. */
  permisos: ReadonlyArray<string>;
  /** Mensaje del banner cuando no pasa el guard · opcional. */
  mensaje?: string;
  children: ReactNode;
}

/**
 * Guard de PERMISO (RBAC · Ruta B) · si el usuario actual no tiene ninguno de
 * los permisos requeridos muestra un alert "Acceso restringido", de lo contrario
 * renderiza `children`.
 *
 * Gemelo de <RoleGate> pero sobre permisos efectivos. El backend es la frontera
 * de seguridad real (bloquea al instante); este guard es solo cosmético/UX.
 * En la Fase 3 reemplaza a <RoleGate> en las pantallas.
 */
export function PermissionGate({ permisos, mensaje, children }: Props) {
  const misPermisos = useUserPermisos();
  const tienePermiso = permisos.some((p) => misPermisos.includes(p));
  if (tienePermiso) return <>{children}</>;
  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <Alert variant="warning" icon={<IconLock size={18} stroke={1.7} />} title="Acceso restringido">
        {mensaje ?? "No tienes permiso para acceder a esta sección."}
      </Alert>
    </div>
  );
}
